import { getStudents, deleteStudent } from "@/api/requests/students";

const loadStudents = async ({ commit, state }, { force }) => {
  if (!force && state.loaded) return;
  commit("setLoading", true);
  try {
    const { data } = await getStudents({ limit: 1000 });
    commit("setStudents", data.rows);
  } catch {
    commit("setStudents", []);
  } finally {
    commit("setLoading", false);
  }
};

export default {
  namespaced: true,

  state: () => ({
    students: [],
    loaded: false,
    isLoading: false,
  }),

  mutations: {
    setStudents(state, students) {
      state.students = students;
      state.loaded = true;
    },
    setLoading(state, loading) {
      state.isLoading = loading;
    },
    addStudent(state, student) {
      state.students.push(student);
    },
    updateStudent(state, student) {
      const index = state.students.findIndex((s) => s.id === student.id);
      if (index !== -1) state.students.splice(index, 1, student);
    },
    removeStudent(state, studentId) {
      state.students = state.students.filter((s) => s.id !== studentId);
    },
  },

  actions: {
    load(ctx) {
      return loadStudents(ctx, { force: false });
    },
    reload(ctx) {
      return loadStudents(ctx, { force: true });
    },
    async delete({ commit }, studentId) {
      await deleteStudent({ studentId });
      commit("removeStudent", studentId);
    },
  },

  getters: {
    students: (state) => state.students,
  },
};
